// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_dJy","cls2":"TopBar-cls2_5zL TopBar-cls1_dJy"};